import { observer } from 'mobx-react-lite'
import { type AlertsManager } from '@/features/shell/alerts/AlertsManager'
import type { Alert } from '@/features/shell/alerts/Alert'
import {
  AlertsHost,
  AlertView,
} from '@/features/shell/alerts/components/AlertsHost'

export interface AlertsHostContainerProps {
  manager: AlertsManager
}

export const AlertsHostContainer = observer(function AlertsHostContainer({
  manager,
}: AlertsHostContainerProps) {
  return (
    <AlertsHost
      alerts={manager.alerts.map((alert) => ({
        id: alert.id,
        content: <AlertViewContainer alert={alert} />,
      }))}
    />
  )
})

export interface AlertViewContainerProps {
  alert: Alert
}

export const AlertViewContainer = observer(function AlertViewContainer({
  alert,
}: AlertViewContainerProps) {
  return (
    <AlertView
      title={alert.title}
      description={alert.description}
      state={alert.state}
      actions={alert.actions.map((action) => ({
        title: action.title,
        onPress: () => alert.triggerAction(action),
      }))}
      onInteract={alert.interact}
      onMouseEnter={alert.cancelAutoDismiss}
      onDismiss={alert.dismiss}
    />
  )
})
